export default __webpack_public_path__ + "static/media/5_1.2fef8fd8.jpg";